import {useMemo} from 'react';
import {useGetStoreProductsQuery} from '../api/storesApi';
import {useStoreSlug} from './useStoreSlug';

export const useShouldForwardToPDP = (params?: {
  skip?: boolean;
}): boolean | null => {
  const skip = params?.skip;
  const storeSlug = useStoreSlug();

  const {data: storeProductResults} = useGetStoreProductsQuery(storeSlug, {
    skip
  });

  const shouldForwardToPDP = useMemo((): boolean | null => {
    if (!storeProductResults || skip) return null;
    return storeProductResults.length === 1;
  }, [storeProductResults, skip]);

  return shouldForwardToPDP;
};

export default useShouldForwardToPDP;
